import { AxiosError } from 'axios';
import useSWRImmutable from 'swr/immutable';

import { apiEndpoints } from '../lib';
import { SimplifiedAccountInfoT } from '../types';

export const useBlocAccountSummary = (accountId: string) => {
  const {
    data,
    error,
    isLoading,
  } = useSWRImmutable<SimplifiedAccountInfoT, AxiosError>(
    accountId ? apiEndpoints.blocAccountSummary(accountId) : null,
  );

  return {
    blocAccountSummary: data,
    error,
    isLoading,
  };
};
